import React from "react";
import PropTypes from "prop-types";
import { CSpinner } from "@coreui/react";
import "./ScreenLoaderStyle.css";

const ScreenLoader = ({ loadingMessage = "Getting things ready..." }) => {
  return (
    <div className="screen-loader">
      <div className="screen-loader-spinner-container">
        <CSpinner className="screen-loader-spinner" />
        <div className="screen-loader-message">{loadingMessage}</div>
      </div>
    </div>
  );
};

ScreenLoader.propTypes = {
  loadingMessage: PropTypes.string,
};

export default ScreenLoader;
